export class UseCaseCreateInvitationTrustPilot {
    async handle(invitationTrustPilot) {
        if (window.tp) {
            window.tp("createInvitation", invitationTrustPilot);
        }
        return invitationTrustPilot;
    }
}
